<template>
  <div>
    <b-card>
      <b-row class="d-flex align-items-start">
        <b-col cols="4">
          <table class="table">
            <thead class="center-th">
              <tr>
                <th scope="col">
                  {{ $t("objects.object") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.object }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">{{ $t("clients.contract") }} №</th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.contract_number }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("clients.full_name") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.fio }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("contract.contract_date") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.date }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("objects.position") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.position }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("apartments.flat_area") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.total_area }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("objects.price_per_m") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(GET_ALL_LIST_TABLE.contract.price_per_kv)
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>
            </thead>
          </table>
        </b-col>
        <b-col cols="4">
          <table class="table">
            <thead class="center-th">
              <tr>
                <th scope="col">
                  {{ $t("contract.initial_fee") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(GET_ALL_LIST_TABLE.contract.initial_fee)
                  }}
                </th>
                <th v-else class="bg-white" scope="col" />
              </tr>
              <tr>
                <th scope="col">
                  {{ $t("objects.installment_from") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.start_date }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("objects.installment_to") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ GET_ALL_LIST_TABLE.contract.end_date }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <!-- <tr>
                <th scope="col">Рассрочка</th>
                <th
                  v-if="this.GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ this.GET_ALL_LIST_TABLE.contract.installment }}
                </th>
                <th v-else class="bg-white"></th>
              </tr> -->

              <tr>
                <th scope="col">
                  {{ this.$t("objects.installment_period") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(
                      GET_ALL_LIST_TABLE.contract.monthly_payment,
                    )
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>
              <tr>
                <th scope="col">
                  {{ this.$t("objects.description") }}
                </th>
                <th scope="col" class="bg-white">
                  {{ GET_ALL_LIST_TABLE.description }}
                </th>
              </tr>
            </thead>
          </table>
        </b-col>
        <b-col cols="4">
          <table class="table">
            <thead class="center-th">
              <tr>
                <th scope="col">
                  {{ $t("objects.installment_price") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(GET_ALL_LIST_TABLE.contract.total_price)
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("clients.paid") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(GET_ALL_LIST_TABLE.contract.paid_amount)
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("reports.total_debt") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{ $_moneyFormatter(GET_ALL_LIST_TABLE.contract.total_debt) }}
                </th>
                <th v-else class="bg-white" />
              </tr>

              <tr>
                <th scope="col">
                  {{ $t("reports.unpaid_amount_installment") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white text-danger"
                  style="font-weight: 900;"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(
                      GET_ALL_LIST_TABLE.contract.total_monthly_debt,
                    )
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>
              <tr>
                <th scope="col">
                  {{ this.$t("contract.issue") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  <div class="d-flex align-items-center justify-content-center">
                    <feather-icon
                      :icon="
                        GET_ALL_LIST_TABLE.contract.register_type
                          ? 'CheckSquareIcon'
                          : 'XSquareIcon'
                      "
                      class="mr-25"
                      :class="
                        GET_ALL_LIST_TABLE.contract.register_type
                          ? 'text-success'
                          : 'text-danger'
                      "
                      size="20"
                    />
                    {{
                      GET_ALL_LIST_TABLE.contract.register_type
                        ? $t("reports.is_formed")
                        : $t("reports.is_not_formed")
                    }}
                  </div>
                </th>
                <th v-else class="bg-white" />
              </tr>
              <tr>
                <th scope="col">
                  {{ this.$t("contract.issue_price") }}
                </th>
                <th
                  v-if="GET_ALL_LIST_TABLE.contract"
                  class="bg-white"
                  scope="col"
                >
                  {{
                    $_moneyFormatter(GET_ALL_LIST_TABLE.contract.register_price)
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>
              <tr>
                <th scope="col">
                  {{ this.$t("contract.issue_date") }}
                </th>
                <th
                  v-if="
                    GET_ALL_LIST_TABLE.contract &&
                      GET_ALL_LIST_TABLE.contract.register_created_at
                  "
                  class="bg-white"
                  scope="col"
                >
                  {{
                    new Date(GET_ALL_LIST_TABLE.contract.register_created_at)
                      .toLocaleDateString()
                      .split(",")[0]
                  }}
                </th>
                <th v-else class="bg-white" />
              </tr>
            </thead>
          </table>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <validation-observer ref="onClient">
        <b-row>
          <b-col cols="3">
            <b-form-group :label="$t('clients.contract')">
              <validation-provider
                #default="{ errors }"
                :name="$t('clients.contract')"
                rules="required"
              >
                <app-select
                  v-model="completed.contract_value"
                  :options="GET_CONTRACTS_V2"
                  :item-selected.sync="completed.contract_value"
                  :get-option-label="(item) => item.contract_number"
                  :lazy-fetch-data="FETCH_CONTRACTS"
                  :search="FETCH_CONTRACTS"
                  :reduce="(item) => item.id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="3">
            <b-form-group :label="$t('general.payment_cashs')">
              <validation-provider
                #default="{ errors }"
                :name="$t('general.payment_cashs')"
                rules="required"
              >
                <v-select
                  v-model="completed.payment_types"
                  :options="mainValue"
                  :get-option-label="(type) => type.title"
                  :reduce="(user) => user.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col class="d-flex align-items-center mt-1" cols="3">
            <b-button variant="success" @click="sendAndAccept">
              {{ $t("general.accept") }}
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <b-card>
      <b-row>
        <div class="col-lg-4">
          <h4 class="text-center">
            {{ $t("clients.bank") }}
          </h4>
          <table class="table">
            <thead class="center-th">
              <tr>
                <th scope="col" class="text-center">
                  №
                </th>
                <th scope="col" class="text-center">
                  {{ $t("sms.date") }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t("finance.summ") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="GET_ALL_LIST_TABLE.transactions">
              <tr
                v-for="(item, index) in GET_ALL_LIST_TABLE.transactions[0]"
                :key="item.id"
              >
                <th class="bg-white text-center" scope="col">
                  {{ index + 1 }}
                </th>
                <th class="bg-white text-center" scope="col">
                  {{ item.paid_at }}
                </th>
                <th class="bg-white text-center" scope="col">
                  {{ $_moneyFormatter(item.amount) }}
                </th>
              </tr>
              <tr v-if="amountTotal">
                <th scope="col" class="text-center">
                  ОБЩАЯ СУММА
                </th>
                <th scope="col" class="text-center" />
                <th scope="col" class="text-center">
                  {{ $_moneyFormatter(amountTotal) }}
                </th>
              </tr>
            </tbody>
          </table>
          <p v-if="!amountTotal" class="text-center mt-1">
            {{ $t("general.no_records_to_show") }}
          </p>
        </div>
        <div class="col-lg-4">
          <h4 class="text-center">
            {{ $t("references.account") }}
          </h4>
          <table class="table">
            <thead class="center-th">
              <tr>
                <th scope="col" class="text-center">
                  №
                </th>
                <th scope="col" class="text-center">
                  {{ $t("sms.date") }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t("finance.summ") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="GET_ALL_LIST_TABLE.transactions">
              <tr
                v-for="(item, index) in GET_ALL_LIST_TABLE.transactions[1]"
                :key="item.id"
              >
                <th class="bg-white text-center" scope="col">
                  {{ index + 1 }}
                </th>
                <th class="bg-white text-center" scope="col">
                  {{ item.paid_at }}
                </th>
                <th class="bg-white text-center" scope="col">
                  {{ $_moneyFormatter(item.amount) }}
                </th>
              </tr>
              <tr v-if="amountTotal2">
                <th scope="col" class="text-center">
                  ОБЩАЯ СУММА
                </th>
                <th scope="col" class="text-center" />
                <th scope="col" class="text-center">
                  {{ $_moneyFormatter(amountTotal2) }}
                </th>
              </tr>
            </tbody>
          </table>
          <p v-if="!amountTotal2" class="text-center mt-1">
            {{ $t("general.no_records_to_show") }}
          </p>
        </div>
        <div class="col-lg-4">
          <h4 class="text-center">
            {{ $t("clients.barter") }}
          </h4>
          <table class="table">
            <thead class="center-th">
              <tr>
                <th scope="col" class="text-center">
                  №
                </th>
                <th scope="col" class="text-center">
                  {{ $t("sms.date") }}
                </th>
                <th scope="col" class="text-center">
                  {{ $t("finance.summ") }}
                </th>
              </tr>
            </thead>

            <tbody v-if="GET_ALL_LIST_TABLE.transactions">
              <tr
                v-for="(item, index) in GET_ALL_LIST_TABLE.transactions[2]"
                :key="item.id"
              >
                <th class="bg-white text-center" scope="col">
                  {{ index + 1 }}
                </th>
                <th class="bg-white text-center" scope="col">
                  {{ item.paid_at }}
                </th>
                <th class="bg-white text-center" scope="col">
                  {{ $_moneyFormatter(item.amount) }}
                </th>
              </tr>
              <tr v-if="amountTotal3">
                <th scope="col" class="text-center">
                  ОБЩАЯ СУММА
                </th>
                <th scope="col" class="text-center" />
                <th scope="col" class="text-center">
                  {{ $_moneyFormatter(amountTotal3) }}
                </th>
              </tr>
            </tbody>
          </table>
          <p v-if="!amountTotal3" class="text-center mt-1">
            {{ $t("general.no_records_to_show") }}
          </p>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import {
  BCard,
  BSpinner,
  BTr,
  BTh,
  BTable,
  BFormInput,
  BCol,
  BRow,
  BButton,
  BFormGroup,
} from "bootstrap-vue";
import VSelect from "vue-select";
import formatters from "@/mixins/extra";
import AppSelect from "@/components/AppSelect.vue";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BCard,
    BButton,
    BFormGroup,
    VSelect,
    BTable,
    BSpinner,
    BCol,
    BRow,
    BTr,
    AppSelect,
    BFormInput,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      required,
      loader: false,
      client_name: "",
      amountTotal: null,
      amountTotal2: null,
      amountTotal3: null,
      payment_name: "",
      completed: {
        contract_value: null,
        payment_types: null,
      },
      mainValue: [
        { title: "Банк", value: "cash" },
        { title: "Счет", value: "noncash" },
        { title: "Бартер", value: "barter" },
      ],
      fields: [
        {
          key: "id",
          label: "ID",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "title",
          label: "Obyekt nomi",
        },
        {
          key: "total_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("objects", [
      "GET_REPORTS_TABLE",
      "GET_OVERALL_TABLE",
      "GET_ALL_LIST_TABLE",
    ]),
    ...mapGetters("contracts", ["GET_CONTRACTS", "GET_CONTRACTS_V2"]),
  },

  mounted() {
    this.FETCH_OVERALL_TABLE();
    this.FETCH_CONTRACTS();
    // this.FETCH_REPORTS_TABLE().then(() => {
    //   this.loader = false;
    // });
  },

  methods: {
    ...mapActions("objects", [
      "FETCH_REPORTS_TABLE",
      "FETCH_OVERALL_TABLE",
      "FETCH_OVERALL_LIST_TABLE",
    ]),
    ...mapActions("contracts", ["FETCH_CONTRACTS"]),
    totalAmount() {
      this.GET_ALL_LIST_TABLE.transactions.forEach((item, index) => {
        if (this.GET_ALL_LIST_TABLE.transactions[index].length) {
          if (index == 0) {
            item.forEach((x) => {
              this.amountTotal += x.amount;
            });
          } else if (index == 1) {
            item.forEach((x) => {
              this.amountTotal2 += x.amount;
            });
          } else if (index == 2) {
            item.forEach((x) => {
              this.amountTotal3 += x.amount;
            });
          }
        }
      });
    },
    async fetchClientsList() {
      const res = await this.FETCH_CONTRACTS();
      console.log("res", res);
      this.clientsList = {
        count: res.count,
        results: res.results,
      };
    },

    sendAndAccept() {
      this.$refs.onClient.validate().then(async (result) => {
        if (result) {
          this.amountTotal = null;
          this.amountTotal2 = null;
          this.amountTotal3 = null;
          this.FETCH_OVERALL_LIST_TABLE({
            data: { payment_type: this.completed.payment_types },
            id: this.completed.contract_value,
          }).then((val) => {
            this.totalAmount();
          });
        }
      });
    },
    onInputContract(item) {
      if (item) {
        this.client_name = item.customer.name;
        this.transaction.contract = item.id;
      } else {
        this.client_name = null;
        this.transaction.contract = null;
      }
    },
  },
};
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}

.center-th th {
  vertical-align: middle !important;
  text-align: center !important;
}
.center-td td {
  vertical-align: middle !important;
  text-align: center !important;
}
</style>
